var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChildbgmbottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 591,
    viewBox: "0 0 1440 591",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V588.552C1440 588.552 1269 523.971 1080 559.706C891 595.441 708.5 567.025 625.5 550.234C542.5 533.443 420 538.179 266.5 569.609C113 601.038 0 588.552 0 588.552V0Z",
    fill: "#7A53FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildbgmbottom);
export default __webpack_public_path__ + "static/media/childbgmbottom.19e8749be8fc99a8d452d03b0fde2aac.svg";
export { ForwardRef as ReactComponent };